import React, { useState, useEffect } from "react";
import FileUploadButton from "./components/file-upload-button/FileUploadButton";
import FileUploadDialog from "./components/file-upload-dialog/FileUploadDialog";
import FileUploadField from "./components/file-upload-field/FileUploadField";
import { DEFAULT_TITLE, REPLACE_TITLE } from "./components/file-upload-dialog/FileUploadDialog.consts";
import { DEFAULT_VARIANT, DEFAULT_FIELD_LABEL, DEFAULT_ACCEPTED_TYPES } from "./FileUpload.consts";

const HyroFileUpload = ({
  onSubmit,
  isReadOnly,
  variant = DEFAULT_VARIANT,
  fieldLabel = DEFAULT_FIELD_LABEL,
  acceptedFileTypes = DEFAULT_ACCEPTED_TYPES,
  error,
  value,
  helperText,
  open: externalOpen,
  onClose: externalClose,
  multiple = true,
  fileToReplace = null,
  preUploadValidation
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(externalOpen || false);

  useEffect(() => {
    if (externalOpen !== undefined) {
      setIsDialogOpen(externalOpen);
    }
  }, [externalOpen]);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    if (externalClose) {
      externalClose();
    }
  };

  const handleSubmit = (files) => {
    onSubmit(files);
    handleCloseDialog();
  };

  if (variant === "field") {
    return (
      <FileUploadField
        error={error}
        onFileSelect={onSubmit}
        isReadOnly={isReadOnly}
        label={fieldLabel}
        acceptedFileTypes={acceptedFileTypes}
        value={value}
        helperText={helperText}
      />
    );
  }

  return (
    <>
      <FileUploadButton onClick={handleOpenDialog} isReadOnly={isReadOnly} />
      <FileUploadDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onSubmit={handleSubmit}
        acceptedFileTypes={acceptedFileTypes}
        multiple={multiple}
        title={multiple ? DEFAULT_TITLE : REPLACE_TITLE}
        fileToReplace={fileToReplace}
        preUploadValidation={preUploadValidation}
      />
    </>
  );
};

export default HyroFileUpload;
